export enum ModalSize {
  XXSMALL = 'xxsmall',
  XSMALL = 'xsmall',
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
  XLARGE = 'xlarge',
  FULLSCREEN = 'fullscreen',
  FIT_CONTENT = 'fit-content',
}
